import { render } from "./App.vue?vue&type=template&id=ec93b196"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ec93b196&lang=scss"

import exportComponent from "C:\\Users\\igor.kondratiev\\Documents\\работа\\проекты\\faq\\faq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__